//NOTE: This ViewModel is only used for practiceEditV2.js and practiceViewV2.js.

//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
// Practice
//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
export class Practice {

    //IDs    
    practice_id = null;
    replacement_practice_id = null;
    reporting_practice_id = null;

    //Codes
    practice_code = null;
    replacement_code = null;
    reporting_code = null;
    practice_type_code = "";

    //Units
    effect_measurement_unit_id = null;
    measurement_unit_id = null;
    impact_measurement_unit_id = null;
    reporting_measurement_unit_id = null;
    
    //Dates
    start_date = null;
    end_date = null;
    
    //General
    installed_practice_lifespan_years = "1";
    national_indicator = null;
    publish = null;
    practice_definition = null;
    practice_display = null;
    practice_name = "";
    authorizedStates = [];
    adoptedStates = [];

    //Narrative Fields
    narrative_climate_smart = false;
    narrative_description = "";


    // INITIALIZATION
    //-------------------------------------------------------------------------------------------------------------------------
    //==================================
    // constructor
    //==================================
    //constructor(){};
}